import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomUrlEncoder } from '../encoders/custom-url.encoder';

@Injectable({
  providedIn: 'root',
})
export class HttpParamsInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const params = new HttpParams({ encoder: new CustomUrlEncoder(), fromString: request.params.toString() });
    return next.handle(request.clone({ params }));
  }
}
